"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMemberById = exports.getMembers = void 0;
var core_1 = __importDefault(require("@/api/core"));
var getMembers = function (_a) {
    var generationNumber = _a.generationNumber, params = __rest(_a, ["generationNumber"]);
    return core_1.default.get({ url: "/members/".concat(generationNumber), params: params });
};
exports.getMembers = getMembers;
var getMemberById = function (_a) {
    var generationNumber = _a.generationNumber, memberId = _a.memberId;
    return core_1.default.get({ url: "/members/".concat(generationNumber, "/").concat(memberId) });
};
exports.getMemberById = getMemberById;
